<script lang="ts" setup>
import ProductForm from "@/data-views/forms/product/Form.vue";
definePage({
  meta: {
    action: "update",
    subject: "Product",
  },
});
</script>

<template>
  <div>
    <ProductForm />
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
